import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionIdentifier, hasValidSessionIdentifier } from "src/helpers/session.helpers";
import { CustomError } from "src/lib/error";
import logger from "src/logger";
import { getBundleList } from "src/services/bundle/bundle.service";
import { TSession } from "src/types/session.type";
import { miniSerializeErrorOverride } from "./serialize-error";

// Thunk to fetch the bundle list
export const getBundleListAction = createAsyncThunk(
  'get/fetchBundleList',
  async (session: TSession) => {
    try {
      if (!session || !hasValidSessionIdentifier(session) || !session.isCustomerAccount) {
        // If the session is not valid or not a customer account, throw an error
        throw new CustomError({ errorCode: 'SessionNotFound' });
      }
      const bundleList = await getBundleList({ ...getSessionIdentifier(session), entitiesToInclude: ['OrderDetails'] });
      return bundleList;
    } catch (err) {
      logger.reportError(err, { message: 'Error in getBundleListAction' });
      throw err;
    }
  },
  {
    serializeError: miniSerializeErrorOverride,
  },
);